import gql from 'graphql-tag';

import { Query, QueryRegistry } from 'core/index';

const SPACES = gql`
  query CanCreateInSpaces {
    canCreateInSpaces(
      type: "Space"
      obj: "{\\"class_name\\": \\"Space\\",\\"space_type\\":{\\"name\\":\\"PROJECT\\"}}"
    ) {
      id
      spaceType
      hasPrivateProjectsSubscription
      hasBillingPermissions
      trialPeriodEnd
      hasValidPaymentMethod
      parent {
        id
        spaceType
      }
      content {
        id
        slug
        avatar {
          id
          path
          url
        }
        imageFallbackChar
        title
      }
    }
  }
`;

export class CanCreateInSpacesQuery extends Query {
  static conf = {
    GQL: SPACES,
    resultPath: 'canCreateInSpaces',
  };
}

const WORKSPACES = gql`
  query Workspaces($type: String, $obj: JSONString) {
    canCreateInSpaces(type: $type, obj: $obj) {
      id
      spaceType
      content {
        id
        slug
        canUpdate
        avatar {
          id
          path
          url
        }
        title
      }
    }
  }
`;

export class WorkspacesQuery extends Query {
  static conf = {
    GQL: WORKSPACES,
    varNames: ['type', 'obj'],
    resultPath: 'canCreateInSpaces',
  };
}

const FILTER_FIELDS = gql`
  fragment FilterFields on Space {
    id
    spaceType
    content {
      id
      slug
      avatar {
        id
        path
        url
      }
      title
      imageFallbackChar
    }
  }
`;

const AUTOCOMPLETE_SPACES = gql`
  ${FILTER_FIELDS}
  query SpacesComplete($complete: String) {
    spacesComplete(complete: $complete) {
      ...FilterFields
    }
  }
`;

export class CompleteSpacesQuery extends Query {
  static conf = {
    GQL: AUTOCOMPLETE_SPACES,
    varNames: ['complete'],
    resultPath: 'spacesComplete',
  };
}

QueryRegistry.add('spaces.CompleteSpacesQuery', CompleteSpacesQuery);

const SPACES_BY_ID = gql`
  ${FILTER_FIELDS}
  query Spaces($ids: [ID]) {
    spaces(ids: $ids) {
      ...FilterFields
    }
  }
`;

export class SpacesQuery extends Query {
  static conf = {
    GQL: SPACES_BY_ID,
    varNames: ['ids'],
    resultPath: 'spaces',
  };
}
